<template>

    <trax-ui-ajax-data-table 
        :id="id" :titles="titles" :bus="bus" :props="props" :endpoint="endpoint" :endpointParams="endpointParams"
        :cols="cols" :header="1"
        :paging="1" :page-length="20" :searching="0"
        order-column="1" order-dir="asc"
    ></trax-ui-ajax-data-table>
    
</template>

<script>
    export default {
    
        props: {
            id: { default: 'home-atp-daf' },
            bus: null
        },

        data: function() {
            return {
                app_url,
                lang: lang,
                user: user,
                cols: [
                    {},
                    {},
                    {},
                    {width: '50px'},
                ],
                titles: [
                    'Description',
                    'Group',
                    'Program',
                    'Status',
                ],
                props: [
                    {source: this.description, orderable: false, class: 'font-weight-bold' },
                    {source: this.group, orderable: false },
                    {source: this.program, orderable: false },
                    {source: this.status, orderable: false, class: 'text-center trax-width-120' },
                ],
                endpoint: app_url+"polaris/api/front/procedures",
                endpointParams: {
                    relations: ['registration', 'phase', 'user', 'users'],
                    accessors: ['location'],
                    sort: ['-date']
                },
            }
        },
        
        methods: {

            // Columns rendering

            description(data, type, row, meta) {
                var type = row.user ? 'ATP' : 'DAF'
                var html = '<b>' + type + ': </b>' + row.name;
                return this.link(row, html);
            },

            group(data, type, row, meta) {
                var html = row.registration.cohort.name;
                if (row.user) html += '<br><small>'+row.user.lastname+' '+row.user.firstname+'</small>';
                if (row.users && row.users.length) html += '<br><small>'+row.users.length+' '+this.lang.polaris.procedure.learners_lc+'</small>';
                return this.link(row, html);
            },

            program(data, type, row, meta) {
                var html = row.registration.program.name;
                html += '<br><small>' + row.phase.name + ' / ' + row.location.name + '<small>'
                return this.link(row, html);
            },

            status(data, type, row, meta) {

                // Status
                var label = row.status;
                var color = 'info';
                if (row.status == 'posted') color = 'warning';
                else if (row.status == 'submitted') color = 'danger';
                else if (row.status == 'validated') color = 'success';
                else if (row.status == 'closed') color = 'default';
                var html = '<span class="badge badge-'+color+'">'+label+'</span>';

                // Date
                var timestamp = moment(row.date);
                timestamp = timestamp.format('DD MMM YYYY');
                html += '<br><small>'+timestamp+'</small>';

                return this.link(row, html);
            },

            link(procedure, content) {
                var href = this.app_url
                    + 'polaris/ui/atpl-dashboard/registration/'
                    + procedure.registration_id
                    + '/procedure/atp-daf/edit/'
                    + procedure.id;

                return '<a href="'+href+'">'+content+'</a>';
            },
        }
    }
</script>
